import calculateFreeShipment from '../general/calculate-free-shipment';

export default function () {
    fetch('/smallcart', { method: 'POST', credentials: 'same-origin' })
        .then(response => response.text())
        .then(data => {
            document.querySelector('[data-role="cart-refresh"]').innerHTML = data;
            calculateFreeShipment();
        });
}